import { render, staticRenderFns } from "./ClientStatuses.vue?vue&type=template&id=083b3b2f&scoped=true"
import script from "./ClientStatuses.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientStatuses.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ClientStatuses.vue?vue&type=style&index=0&id=083b3b2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083b3b2f",
  null
  
)

export default component.exports